import { useEffect, useState } from 'react';
import './Header.scss';
import { useLocation, useNavigate } from "react-router";
import { Menu, MenuItem, MenuMenu, Header as HeaderSemantic, Dropdown, DropdownMenu, DropdownItem, DropdownDivider, Popup, Button, Icon } from 'semantic-ui-react';
import api from '../../utils/api';
import UserInfo from '../../structures/userInfo';
import Project from '../../structures/project';
import LoginModal from './components/LoginModal/LoginModal';
import ComunityPopup from './components/ComunityPopup/ComunityPopup';
import { setToken } from '../../utils/authHelper';
import LogoutModal from './components/LogoutModal/LogoutModal';
import ProfileModal from './components/ProfileModal/ProfileModal';

function Header() {
  const [userInfo, setUserInfo] = useState<UserInfo|null>(null)
  const [project, setProject] = useState<Project|null>(null)
  const [loginModalIsOpen, setLoginModalIsOpen] = useState(false)
  const [profileModalIsOpen, setProfileModalIsOpen] = useState(false)
  const [logoutModalIsOpen, setLogoutModalIsOpen] = useState(false)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const loadProject = () => {
    if(pathname.split('/').length >= 2 && pathname.split('/')[1] === 'project') {
      let projectId = pathname.split('/')[2]
      api.getProjects().then(projects => {
        projects.filter(x=>x.id === projectId).map(x=>setProject(x));
      })
    }else{
      setProject(null)
    }
  }

  useEffect(() => {
    loadProject()
    console.log('URL changed to:', pathname)
  }, [pathname]);
  useEffect(() => {
    api.getUserInfo().then(userInfo => {
      setUserInfo(userInfo)
      loadProject()
      if(userInfo == null){
        if ('VKIDSDK' in window) {
          const VKID = window.VKIDSDK as any;
          const floatingOneTap = new VKID.FloatingOneTap();
          floatingOneTap.render({
            appName: 'Story maker',
            oauthList: [
              'ok_ru',
              'mail_ru'
            ],
            showAlternativeLogin: true
          })
          .on(VKID.WidgetEvents.ERROR, vkidOnError)
          .on(VKID.FloatingOneTapInternalEvents.LOGIN_SUCCESS, function (payload) {
            const code = payload.code;
            const deviceId = payload.device_id;

            VKID.Auth.exchangeCode(code, deviceId)
              .then(vkidOnSuccess)
              .catch(vkidOnError);
          });
        
          function vkidOnSuccess(data) {
            floatingOneTap.close();
            api.vkAuthorize(data).then(response => {
                setToken(response.token);
                navigate('/');
            })            
          }   
          function vkidOnError(error) {
            // Обработка ошибки
          }   
        }        
      }
    });
  }, [])
  return <div className='header'>
    <Menu secondary size='small' attached='top'>
      {project == null ? <>
        <MenuItem>
          <img alt='logo' src='/favicon.svg' /> <b className='site-name'>STORY-MAKER.PRO</b>
        </MenuItem>
        <MenuItem
          active={pathname == '/'}
          onClick={() => {navigate('/')}}
        >Проекты</MenuItem>
        {userInfo != null && <MenuItem
          active={pathname == '/my-projects'}
          onClick={() => {navigate('/my-projects')}}
        >Мои проекты</MenuItem>}
        <MenuItem
          active={pathname == '/authors'}
          onClick={() => {navigate('/authors')}}
        >Авторы</MenuItem>      
        <MenuItem
          active={pathname == '/how-it-works'}
          onClick={() => {navigate('/how-it-works')}}
        >Как это работает?</MenuItem>      
        <Popup 
          basic 
          on='click'
          pinned
          position='bottom center'
          trigger={<MenuItem>Сообщество</MenuItem>} 
          className='comunity-popup'
          content={<ComunityPopup/>} />
      </> : <>
        <Dropdown item icon={<img alt='logo' src='/favicon.svg' />}>
          <DropdownMenu>
            <DropdownItem onClick={() => {navigate('/my-projects')}}><Icon name='bars'/> Мои проекты</DropdownItem>
            <DropdownItem onClick={() => {navigate('/')}}><Icon name='book'/> Все проекты</DropdownItem>
            <DropdownItem onClick={() => {navigate('/authors')}}><Icon name='users'/> Авторы</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Dropdown item icon={<HeaderSemantic className='project-name' as='h4'>{project.name} <span className='percent'>(5%)</span></HeaderSemantic>}>
          <DropdownMenu>
            <DropdownItem><Icon name='external alternate'/> Открыть черновик</DropdownItem>
            <DropdownItem><Icon name='settings'/> Настройки</DropdownItem>
            <Button fluid primary size='tiny' disabled icon><Icon name='share alternate'/> Опубликовать</Button>
          </DropdownMenu>
        </Dropdown>
        <MenuItem
          active={pathname.startsWith('/project/' + project.id) && !pathname.startsWith('/project/' + project.id + '/heroes') && !pathname.startsWith('/project/' + project.id + '/places') && !pathname.startsWith('/project/' + project.id + '/objects')}
          onClick={() => {
            if(!(pathname.startsWith('/project/' + project.id) && !pathname.startsWith('/project/' + project.id + '/heroes') && !pathname.startsWith('/project/' + project.id + '/places') && !pathname.startsWith('/project/' + project.id + '/objects')))
              navigate('/project/' + project.id)
          }}
        >Содержание</MenuItem>
        <MenuItem
          active={pathname.startsWith('/project/' + project.id + '/heroes')}
          onClick={() => {navigate('/project/' + project.id + '/heroes')}}
        >Персонажи</MenuItem>
        <MenuItem
          active={pathname.startsWith('/project/' + project.id + '/places')}
          onClick={() => {navigate('/project/' + project.id + '/places')}}
        >Места</MenuItem>
        <MenuItem
          active={pathname.startsWith('/project/' + project.id + '/objects')}
          onClick={() => {navigate('/project/' + project.id + '/objects')}}
        >Предметы</MenuItem>
      
      </>}

      <MenuMenu position='right'>
        {project != null && <Dropdown item icon={<div><b>3</b> креативных часа</div>}>
          <DropdownMenu>
            <p style={{width: '180px', whiteSpace: 'normal', padding: '15px'}}>Креативные часы позволяют вам совершать не ограниченное количество вызовов ИИ во время их использования.</p>
            <DropdownDivider />
            <DropdownItem disabled><Icon name='play'/> Использовать</DropdownItem>
            <DropdownDivider />
            <DropdownItem><Icon name='gift'/> Получить</DropdownItem>
            <DropdownItem><Icon name='cart arrow down'/> Купить</DropdownItem>
          </DropdownMenu>
        </Dropdown>} 
        {project != null && <MenuItem>
          <Popup 
            basic 
            inverted 
            trigger={<div><b>54 654</b>&nbsp;токена</div>} 
            position='bottom center'
            content={<div>
              Токены расходуются при каждом вызове ИИ для генерации и редактирования контента проекта.
              <hr/>
              Токены пополняются автоматически <b>каждый час</b> и полностью восполняются за <b>24 часа</b>.
              <br/>
              Максимальное количество токенов <b>10 000</b>.
            </div>}
          /></MenuItem>} 
        {userInfo == null ? <MenuItem onClick={() => {setLoginModalIsOpen(true)}}><a>Войти/Зарегистрироваться</a></MenuItem> : <Dropdown item icon={<div className='user-info'><img src={userInfo?.avatar}/> {userInfo?.firstName} {userInfo?.lastName}</div>}>
          <DropdownMenu>
            <DropdownItem onClick={() => {setProfileModalIsOpen(true)}}><Icon name='user circle outline'/> Профиль</DropdownItem>
            <DropdownItem><Icon name='external alternate'/> Моя страница</DropdownItem>
            <DropdownDivider />
            <DropdownItem onClick={() => {setLogoutModalIsOpen(true)}}><Icon name='sign-out'/> Выход</DropdownItem>
          </DropdownMenu>
        </Dropdown>}
      </MenuMenu>
    </Menu>
    <LoginModal open={loginModalIsOpen} setOpen={setLoginModalIsOpen} onLogin={() => {}}/>
    <ProfileModal open={profileModalIsOpen} setOpen={setProfileModalIsOpen} onSave={() => {}}/>
    <LogoutModal open={logoutModalIsOpen} setOpen={setLogoutModalIsOpen} onLogout={() => {navigate('/')}}/>
  </div>;
}

export default Header;
